import { BASE_URL } from "config";
import { api } from "utils";
import * as base from '../base';


const endpoints = {
  list: `${BASE_URL}/api/v1/seo/extlinksite/`,
};

export const seoExtLinkSiteListLoad = (token, payload) => api.ListLoad(endpoints.list, token, payload);

export const seoExtLinkSite = {
  state: {
    ...base.ListState,

    title: 'Внешние ссылки: сайты',
    urls: {
      list: (seoExtDomain) => `/extlink/${seoExtDomain}/sites`,
    },
  },
  reducers: {
    ...base.ListReducers,
  },
  effects: dispatch => ({
    async listLoad(payload, rootState) {
      await base.asyncListLoadRequest(dispatch, payload, rootState, 'seoExtLinkSite', seoExtLinkSiteListLoad)
    },
  }),
}